import React from "react";
import {Route, Switch} from "react-router-dom";

import asyncComponent from "util/asyncComponent";

const App = ({match}) => (
  <div className="gx-main-content-wrapper">
    <Switch>
      <Route exact path={`${match.url}`} component={asyncComponent(() => import('./Main'))}/>
      <Route exact path={`${match.url}/productsList`} component={asyncComponent(() => import('./ProductsList'))}/>
      <Route exact path={`${match.url}/editProducts`} component={asyncComponent(() => import('./ProductsEdit'))}/>
      <Route exact path={`${match.url}/addProduct`} component={asyncComponent(() => import('./ProductsAdd'))}/>
      <Route exact path={`${match.url}/clientAffiliatesList`} component={asyncComponent(() => import('./ClientsList'))}/>
      <Route exact path={`${match.url}/clientAffiliatesRequest`} component={asyncComponent(() => import('./ClientsRequests'))}/>
      <Route exact path={`${match.url}/clientsInvitations`} component={asyncComponent(() => import('./ClientsInvitations'))}/>
      <Route exact path={`${match.url}/ordersList`} component={asyncComponent(() => import('./OrdersList'))}/>
      <Route exact path={`${match.url}/ordersComplete`} component={asyncComponent(() => import('./OrdersCompleted'))}/>
      <Route exact path={`${match.url}/ordersWaiting`} component={asyncComponent(() => import('./OrdersWaiting'))}/>
      <Route exact path={`${match.url}/ordersCancelled`} component={asyncComponent(() => import('./OrdersCancelled'))}/>
      {/* <Route exact path={`${match.url}/ordersEdit`} component={asyncComponent(() => import('./OrdersEdit'))}/> */}
      <Route exact path={`${match.url}/invoices`} component={asyncComponent(() => import('./InvoicesList'))}/>
      <Route exact path={`${match.url}/editProfile`} component={asyncComponent(() => import('./EditProfile'))}/>
    </Switch>
  </div>
);

export default App;
